import { faLink, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

type CopyLinkButtonProps = {
  url: string;
};

const CopyLinkButton = ({ url }: CopyLinkButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback for browsers without clipboard API
      const el = document.createElement("textarea");
      el.value = url;
      el.style.position = "fixed";
      el.style.opacity = "0";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        aria-label="Copy link"
        onClick={handleCopy}
        className={`flex h-10 w-10 items-center justify-center transition-colors duration-150 ${
          copied
            ? "bg-signal text-white"
            : "bg-theme-surface text-theme-text hover:bg-signal hover:text-white"
        }`}
      >
        <FontAwesomeIcon icon={copied ? faCheck : faLink} className="text-base" />
      </button>
      {copied && (
        <div role="status" className="pointer-events-none absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap bg-plate px-2.5 py-1 font-display text-xs font-semibold text-plate-ink shadow-float">
          Copied!
        </div>
      )}
    </div>
  );
};

export default CopyLinkButton;
